import type { ReceiptListQuery } from '@chukua/common';

/**
 * Whether the receipts query narrows the list. `useListQuery.isFiltered` only counts `q` and the multi-value filters, so the date range,
 * which is two scalars, would show "No receipts yet" for a range that simply matches nothing.
 */
export function isReceiptQueryFiltered(
  query: Partial<Pick<ReceiptListQuery, 'q' | 'channel' | 'status' | 'companyAccountId' | 'customerId' | 'receivedFrom' | 'receivedTo'>>,
): boolean {
  const { q, receivedFrom, receivedTo } = query;
  // Named, not "every other key": the query also carries page, sort and order, which are not filters.
  const multiValue = [query.channel, query.status, query.companyAccountId, query.customerId];
  return Boolean(q || receivedFrom || receivedTo || multiValue.some((values) => values?.length));
}
